// extracted by mini-css-extract-plugin
module.exports = {"boxList":"BoxList_boxList__Q6GHC","boxListTitle":"BoxList_boxListTitle__ujYv_"};